import { makeAutoObservable } from 'mobx'

export type SubscriptionWsStatus =
  | 'unavailable'
  | 'connecting'
  | 'connected'
  | 'disconnected'
  | 'reconnecting'
  | 'error'

export interface SubscriptionDebugEvent {
  id: string
  at: string
  kind: 'ws' | 'subscription' | 'error'
  name: string
  detail?: string
  payload?: unknown
}

const MAX_EVENTS = 50

export default class SubscriptionDebug {
  wsStatus: SubscriptionWsStatus = 'unavailable'
  wsUrl = ''
  lastWsError: string | null = null
  events: SubscriptionDebugEvent[] = []

  constructor() {
    makeAutoObservable(this)
  }

  setWsUrl(url: string) {
    this.wsUrl = url
  }

  setWsStatus(status: SubscriptionWsStatus) {
    this.wsStatus = status
  }

  setLastWsError(message: string | null) {
    this.lastWsError = message
  }

  logEvent(event: Omit<SubscriptionDebugEvent, 'id' | 'at'>) {
    const entry: SubscriptionDebugEvent = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      at: new Date().toISOString(),
      ...event,
    }

    this.events = [entry, ...this.events].slice(0, MAX_EVENTS)
  }

  clearEvents() {
    this.events = []
    this.lastWsError = null
  }

  get statusLabel() {
    switch (this.wsStatus) {
      case 'connected':
        return 'Connected'
      case 'connecting':
        return 'Connecting'
      case 'reconnecting':
        return 'Reconnecting'
      case 'disconnected':
        return 'Disconnected'
      case 'error':
        return 'Error'
      default:
        return 'Unavailable'
    }
  }
}
